import { Component, Input, OnDestroy, ViewEncapsulation } from "@angular/core";

import { MatDialog } from "@angular/material/dialog";

import { Observable, Subscription } from "rxjs";
import { select, Store } from "@ngrx/store";
import { AppState, siteMultimediaLoadedState } from "src/app/store/reducers";
import { getSiteMultimediaList } from "src/app/store/actions/sites/sites.actions";

import { SiteMultimediaDTO } from "src/app/models/Sites/siteMultimediaDTO";

import { MultimediaFormDialogComponent } from "./dialog/multimedia-form-dialog.component";

@Component({
  selector: "site-multimedia-details",
  templateUrl: "./multimedia-details.component.html",
  styleUrls: ["./multimedia-details.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class MultimediaDetailsComponent implements OnDestroy {
  _siteCode: string;

  @Input() set siteCode(code: string) {
    this._siteCode = code;
    if (this._siteCode) {
      this.loadMultimediaDevices(this._siteCode);
    }
  }

  multimediaList$: Observable<SiteMultimediaDTO[]>;
  multimediaList: SiteMultimediaDTO[];
  multimediaSub: Subscription;

  currentMultimedia: SiteMultimediaDTO;
  isMultimediaSelected = false;

  constructor(
    private store: Store<AppState>,
    public dialog: MatDialog
  ) {
    this.multimediaList$ = this.store.pipe(select(siteMultimediaLoadedState));
  }

  loadMultimediaDevices(siteCode: string) {
    this.multimediaSub = this.multimediaList$.subscribe(
      (multimediaDevices: SiteMultimediaDTO[]) => {
        this.multimediaList = multimediaDevices;
        if (multimediaDevices && multimediaDevices.length && this.currentMultimedia) {
          const { code: currentMultimediaCode } = this.currentMultimedia;
          this.currentMultimedia = multimediaDevices.find(({ code }) => code === currentMultimediaCode);
        }
        this.resetMultimedia();
      }
    );
    this.store.dispatch(getSiteMultimediaList({ 
      code: siteCode,
      pageReq: { realSize: true, offset: 0, limit: 999 },
    }));
  }

  resetMultimedia() {
    this.dialog.closeAll();
    this.isMultimediaSelected = false;
    this.currentMultimedia = null;
  }

  selectMultimedia(multimediaDevice: SiteMultimediaDTO) {
    this.isMultimediaSelected = true;
    this.currentMultimedia = multimediaDevice;

    this.openMultimediaFormDialog(false);
  }

  create() {
    this.isMultimediaSelected = false;
    this.currentMultimedia = null;

    this.openMultimediaFormDialog(true);
  }

  openMultimediaFormDialog(isCreate: boolean) {
    this.dialog.open(MultimediaFormDialogComponent, {
      autoFocus: false,
      data: {
        isCreate: isCreate,
        siteCode: this._siteCode,
        currentMultimedia: this.currentMultimedia,
      }
    });
  }

  ngOnDestroy(): void {
    if (this.multimediaSub) {
      this.multimediaSub.unsubscribe();
    }
  }
}
